import { render, staticRenderFns } from "./DependencyForm.vue?vue&type=template&id=f154ce86"
import script from "./DependencyForm.vue?vue&type=script&lang=js"
export * from "./DependencyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports